__turbopack_context__.v({
  "error": "error-module-scss-module__-S4gxW__error",
  "error-icon": "error-module-scss-module__-S4gxW__error-icon",
  "error-icon-circle": "error-module-scss-module__-S4gxW__error-icon-circle",
  "error-icon-header": "error-module-scss-module__-S4gxW__error-icon-header",
  "error-icon-text": "error-module-scss-module__-S4gxW__error-icon-text",
  "error-icon-triangle": "error-module-scss-module__-S4gxW__error-icon-triangle",
  "error-icon-triangle-text": "error-module-scss-module__-S4gxW__error-icon-triangle-text",
  "error-subtext": "error-module-scss-module__-S4gxW__error-subtext",
  "error-title": "error-module-scss-module__-S4gxW__error-title",
});
